import { css } from '@emotion/react'
import clsx from 'clsx'
import React from 'react'

type Option = { label: string; name: string; value: boolean }

type Props = {
  onSelect: (option: Record<string, string | boolean>) => void
  options: Option[]
}

// RADIO FILTER OPTION
//  a group of options where only one can be selected
// ex: claimed or unclaimed jobs

export const RadioFilterOption = ({ onSelect, options }: Props) => {
  const onChange = (selectedOption) => {
    const updatedOptions = options.reduce((prev, opt) => {
      if (selectedOption?.name === opt?.name) {
        return {
          ...prev,
          [opt?.name]: !opt.value,
        }
      } else {
        return {
          ...prev,
          [opt?.name]: false,
        }
      }
    }, {})
    onSelect(updatedOptions)
  }

  return (
    <>
      {options?.map((option, i) => {
        const last = i === options?.length - 1
        return (
          <button
            className={clsx(
              'flex items-center py-3 px-4 border-grey-100',
              // first && 'border-t',
              last && 'border-b',
            )}
            css={hoverStyles}
            key={option?.name}
            onClick={() => onChange(option)}
          >
            <div className="mr-3">
              <EmptyCircle>{option?.value && <FilledCircle />}</EmptyCircle>
            </div>
            <div className={clsx('flex-1 text-label-sm', option?.value && 'text-text-link')}>{option?.label}</div>
          </button>
        )
      })}
    </>
  )
}

const hoverStyles = css`
  &:first-child:hover {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  &:hover {
    background-color: #f3f3f2;
  }
`

const EmptyCircle = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    {...props}
    className={clsx('border-2 border-action-primary flex items-center justify-center', className)}
    style={{ width: '20px', height: '20px', borderRadius: '50%' }}
  />
)

const FilledCircle = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    {...props}
    className={clsx('bg-action-primary', className)}
    style={{ width: '12px', height: '12px', borderRadius: '50%' }}
  />
)
